export const NODE_LIBRARY = [
  { kind: 'trigger', title: 'Trigger', color: '#f59e0b' },
  { kind: 'send_message', title: 'Send Message', color: '#25d366' },
  { kind: 'ai', title: 'AI Node', color: '#4dd5c2' },
  { kind: 'knowledge_base', title: 'AI Knowledge Base', color: '#8cf2b6' },
  { kind: 'conditional', title: 'Conditional', color: '#f7c45c' },
  { kind: 'api_call', title: 'API Call', color: '#7ab2ff' }
];

export const MESSAGE_TYPES = [
  'text',
  'template',
  'image',
  'video',
  'document',
  'audio',
  // 'sticker',
  // 'location',
  // 'contact',
  // 'interactive_buttons',
  // 'interactive_list',
  // 'interactive_product',
  // 'interactive_flow'
];

export const OPERATORS = [
  'equals',
  'not_equals',
  'contains',
  'not_contains',
  'greater_than',
  'less_than',
  'exists',
  'is_empty'
];

export function uid(prefix) {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}

export function defaultConfig(kind) {
  if (kind === 'trigger') {
    return {
      triggerType: 'webhook_event'
    };
  }

  if (kind === 'send_message') {
    return {
      platform: 'whatsapp',
      to: '{{recipient_id}}',
      phoneNumberId: '{{phone_number_id}}',
      recipientSource: 'contact.phone',
      messageType: 'text',
      text: '',
      message: '',
      templateName: '',
      templateId: '',
      templateLanguage: 'en_US',
      mediaUrl: '',
      mediaCaption: '',
      locationName: '',
      latitude: '',
      longitude: '',
      contactJson: '{\n  "name": "John Doe",\n  "phones": []\n}',
      interactiveJson: '{\n  "buttons": []\n}',
      variableMappingJson: '{\n  "name": "{{contact.first_name}}"\n}',
      payload: {
        text: {
          body: ''
        }
      }
    };
  }

  if (kind === 'ai') {
    return {
      provider: 'google',
      apiKey: '',
      model: 'gemini-1.5-pro',
      systemPrompt: 'You are a support assistant. Be concise.',
      userPrompt: 'Summarize customer issue and suggest next action.',
      temperature: 0.2,
      maxTokens: 350,
      inputContextJson: '{\n  "last_message": "{{conversation.last_message}}"\n}',
      outputVariable: 'ai.output_text',
      prompt: {
        system: 'You are a support assistant. Be concise.'
      },
      generation: {
        temperature: 0.2,
        maxTokens: 350
      },
      responseField: 'aiReply'
    };
  }

  if (kind === 'knowledge_base') {
    return {
      provider: 'whatgrowpro',
      apiKey: '',
      model: 'whatgrowpro',
      prompt: {
        system: "Answer the user's question using the provided knowledge base. If the answer is not found, reply politely that the information is unavailable."
      },
      kbId: '',
      queryTemplate: '{{conversation.last_message}}',
      topK: 5,
      minScore: 0.65,
      includeCitations: true,
      outputVariable: 'kb.context',
      fallbackBehavior: 'continue_without_context',
      responseField: 'aiReply',
      phone_number_id: '',
      phoneNumberId: '{{phone_number_id}}',
      userFiles: []
    };
  }

  if (kind === 'conditional') {
    return {
      logic: 'all',
      rules: [{ id: uid('rule'), left: 'contact.intent', operator: 'equals', right: 'support' }],
      source: 'message.text.body',
      operator: 'contains',
      value: '',
      trueNode: '',
      falseNode: ''
    };
  }

  return {
    method: 'POST',
    url: '',
    authType: 'none',
    token: '',
    timeoutMs: 10000,
    retryCount: 1,
    headersJson: '{\n  "Content-Type": "application/json"\n}',
    queryJson: '{\n}',
    bodyJson: '{\n}',
    headers: { 'Content-Type': 'application/json' },
    query: {},
    body: {},
    saveResponseAs: 'api.response',
    successVariable: 'api.response',
    errorVariable: 'api.error',
    failStrategy: 'continue'
  };
}

export function makeNode(kind, position) {
  const meta = NODE_LIBRARY.find((n) => n.kind === kind);
  return {
    id: uid('node'),
    type: 'editableNode',
    position,
    data: {
      kind,
      title: meta?.title || kind,
      color: meta?.color || '#25d366',
      config: defaultConfig(kind)
    }
  };
}



